import React from "react";
import HOC from "../../../components/HOC";
import DetailAllocation from "../../../components/screen/centralWarehouse/allocation/DetailAllocation";
import PageTemplate from "../../../components/common/particles.jsx/PageTemplate";

const DetailReturnWarehousePage = () => {
  return (
    <div className="">
      <PageTemplate
        header="Retur Warehouse Details"
        mainComponent={<DetailAllocation type={3} />}
        pageRole={36}
      />
    </div>
  );
};

export default HOC(DetailReturnWarehousePage);
